module.exports = __webpack_public_path__ + "img/Support-skill-511.32bf6012.png";